import { render, staticRenderFns } from "./ClickAndBuyCompanyForm.vue?vue&type=template&id=5f2b9462&scoped=true"
import script from "./ClickAndBuyCompanyForm.vue?vue&type=script&lang=js"
export * from "./ClickAndBuyCompanyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2b9462",
  null
  
)

export default component.exports